const SECTIONS = [
  {
    title: "제1조 (수집하는 개인정보 항목)",
    body: "ARTPASS(이하 '서비스')는 회원가입 시 이메일, 비밀번호, 이름(표시명)을 수집합니다. 서비스 이용 과정에서 접속 시의 User-Agent(브라우저/기기 정보)가 자동으로 수집되며, 회원이 선택적으로 지갑을 연결하는 경우 지갑 주소가 수집됩니다. 비밀번호는 원문이 아닌 해시 값으로만 저장되어 서비스도 원문을 알 수 없습니다.",
  },
  {
    title: "제2조 (수집 방법)",
    body: "개인정보는 회원가입 및 서비스 이용 과정에서 회원이 직접 입력하거나, 접속 시 자동으로 수집됩니다.",
  },
  {
    title: "제3조 (개인정보의 이용 목적)",
    body: "수집한 정보는 계정 인증 및 세션 유지, 작품 등록·심사·발행 및 소유권 이전 절차의 처리, 부정 이용 방지와 서비스 보안 유지를 위해 이용됩니다.",
  },
  {
    title: "제4조 (개인정보의 보관 및 파기)",
    body: "비밀번호는 bcrypt로 해시화하여 저장하며, 로그인 세션 토큰은 원문이 아닌 SHA-256 해시 값으로 저장되고 httpOnly 쿠키를 통해서만 전달됩니다. 개인정보는 회원 탈퇴 시 또는 수집·이용 목적을 달성한 때까지 보관되며, 관련 법령에 따라 별도 보존 의무가 있는 경우에는 해당 기간 동안 보관될 수 있습니다.",
  },
  {
    title: "제5조 (업로드 파일의 처리)",
    body: "작품 이미지 등 업로드 파일은 서비스 서버의 로컬 스토리지에 저장되며, 공개(PUBLIC)·내부(INTERNAL)·민감(SENSITIVE) 접근 등급에 따라 접근이 제어됩니다. 등록 작품의 대표 이미지 등 공개로 지정된 파일은 로그인 없이 공개 검증 페이지에서 누구나 조회할 수 있으며, 그 외 파일은 업로더·작품 등록자·등록관리자만 접근할 수 있습니다.",
  },
  {
    title: "제6조 (제3자 제공 및 외부 서비스)",
    body: "서비스는 회원의 개인정보를 원칙적으로 제3자에게 제공하지 않으며, 외부 분석·광고·트래킹 도구를 사용하지 않습니다. 이메일이나 문자메시지 등 외부 발송 수단은 사용하지 않고, 모든 알림은 서비스 내 인앱 알림으로만 제공됩니다. 다만 소유권 이전 등 온체인에 기록되는 작품 정보의 해시 값과 지갑 주소는 블록체인의 특성상 해당 체인에 접근할 수 있는 누구에게나 조회될 수 있습니다.",
  },
  {
    title: "제7조 (이용자의 권리)",
    body: "회원은 마이페이지에서 자신의 계정 정보를 열람·수정할 수 있으며, 연결된 지갑 연결을 해제할 수 있습니다(비밀번호 재확인 필요). 그 밖의 열람·정정·삭제·처리정지 요청은 등록관리자에게 문의해주세요.",
  },
  {
    title: "제8조 (개인정보 보호를 위한 조치)",
    body: "서비스는 비밀번호와 로그인 세션 토큰을 해시화하여 저장하고, 모든 상태 변경 요청에 CSRF 더블서브밋 쿠키 검증을 적용하는 등 기술적 조치를 통해 개인정보를 보호합니다.",
  },
  {
    title: "제9조 (문의)",
    body: "개인정보 처리에 관한 문의사항은 등록관리자에게 문의해주세요.",
  },
  {
    title: "부칙",
    body: "이 개인정보처리방침은 2026년 8월 13일부터 적용됩니다.",
  },
];

export function PrivacyContent() {
  return (
    <div className="flex flex-col gap-5">
      {SECTIONS.map((s) => (
        <section key={s.title}>
          <h3 className="mb-1.5 text-sm font-medium text-ink">{s.title}</h3>
          <p className="text-sm leading-relaxed text-body">{s.body}</p>
        </section>
      ))}
    </div>
  );
}
